import {Injectable} from '@angular/core';
import {UserModel} from '../../models/UserModel';
import {ProjectConstants} from '../../app/project-constants';
import {HttpRequest} from '@angular/common/http';

@Injectable()
export class AuthService extends ProjectConstants{
  constructor() {
    super();
  }

  user: UserModel;
  cachedRequests: Array<HttpRequest<any>> = [];

  public isAuthenticated(): boolean {
    const token = sessionStorage.getItem('authToken');
    return !!token;
  }

  public getToken(): string {
    return sessionStorage.getItem('authToken');
  }

  public isPageAvailable(): boolean {
    let result = false;
    this.user = JSON.parse(sessionStorage.getItem('user'));
    if (this.user) {
      switch (this.user.roleList[0]) {
        case this.ROLE.GESTORE_CONTRACT:
          result = true;
          break;
        case this.ROLE.ADMIN:
          result = true;
          break;
        default:
          result = true;
      }
    }

    return result;
  }

  public collectFailedRequest(request): void {
    this.cachedRequests.push(request);
  }

  public retryFailedRequests(): void {
    // retry the requests. this method can
    // be called after the token is refreshed
  }

}
